import script from "./EnglishGamePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishGamePage.vue?vue&type=script&setup=true&lang=ts"

import "./EnglishGamePage.vue?vue&type=style&index=0&id=2331e00a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2331e00a"]])

export default __exports__